import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DateFilter from './DateFilter';

interface ScheduleWeekDateFilterProps {
  handleNext: () => void;
  handlePrev: () => void;
}

function ScheduleWeekDateFilter({ handleNext, handlePrev }: ScheduleWeekDateFilterProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <IconButton onClick={handlePrev} data-testid='prev-week-button'>
        <ChevronLeft />
      </IconButton>
      <DateFilter
        useChips={false}
        controllerName='dateRange'
        disableFutureDates={false}
        onlyFilterContainer={false}
        predefined
        weekFilterSettings={{
          localeName: 'schedule-offset',
          weekFilterControllerName: 'datePickerNav',
        }}
        numberOfCalendars={isMobile ? 1 : 2}
      />
      <IconButton onClick={handleNext} data-testid='next-week-button'>
        <ChevronRight />
      </IconButton>
    </>
  );
}

export default ScheduleWeekDateFilter;
